import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;

import './lib/foundation-explicit-pieces';
// Custom libs
import './lib/fontawesome';
import './lib/fa-icons-custom';
import './lib/utmkeeper';
require ('./lib/jquery.ihavecookies');
require ('./lib/google-optimize');
require ('./lib/listeners');
if ($('#instafeed-list').length > 0) {
  require ('./lib/instafeed');
}
if ($('#sec_reviews').length > 0) {
  require ('./lib/facebook-reviews');
}
require ('./lib/countdown');
require ('./lib/banner-countdown');

if ($('#fever-widget').length > 0 && $('#widget').length > 0 && !$('#widget').is('[data-optimizely-abtest]')) {
  require('./lib/fever-widget');
}
if ($('#optimizely-conf').length > 0) {
  require('./lib/optimizely-application');
}

$(document).foundation();

// Close offcanvas when click on item menu
$('.off-canvas li').on('click', function () {
  $('.off-canvas').foundation('close');
});
